<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    to: String,
    icon: String,
    type: String
    
})

</script>

<template>
    <router-link v-if="props.type !== 'group'" :to="props.to" class="nav-link d-flex text-light" active-class="bg-light text-dark" exact-active-class="bg-light text-dark">
        <div class="" style="width: 15%">
            <i :class="'nav-icon ' + props.icon"></i>
        </div>
        <div class="">
            <p>
                <slot></slot>
            </p>
        </div>
    </router-link>

    <router-link v-if="props.type==='group'" :to="props.to" class="text-white " :class="{'d-flex align-items-center bg-light rounded-lg p-2 my-2': $route.path === props.to, 'text-muted py-2': $route.path !== props.to}"  active-class="bg-light text-dark" exact-active-class="bg-light text-dark">
        <p class="nav-link-group" :class="{'mb-0': $route.path === props.to, '': $route.path !== props.to}"><slot></slot></p>
    </router-link>
</template>

<style>
.nav-link-group:hover {
    color: rgb(177, 177, 177);
}
</style>